import { render, staticRenderFns } from "./OutagesNav.vue?vue&type=template&id=029b5ffc"
import script from "./OutagesNav.vue?vue&type=script&lang=js"
export * from "./OutagesNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports